export default __webpack_public_path__ + "static/media/numberwizard.d65410ec.png";